// Reine Hilfsfunktionen rund um Trainingsergebnisse (ohne React-Abhängigkeiten).

export const createDefaultErgebnisse = (count = 3) => ({
    saetze: Array.from({ length: count }, () => ({
        wiederholungen: '',
        gewicht: '',
        dropsaetze: [],
    })),
});

export const normalizeErgebnis = (data) => {
    if (!data) return createDefaultErgebnisse();
    if (Array.isArray(data)) {
        return { saetze: data.map(s => ({ ...s, dropsaetze: s.dropsaetze || [] })) };
    }
    return {
        saetze: Array.isArray(data.saetze)
            ? data.saetze.map(s => ({ ...s, dropsaetze: Array.isArray(s.dropsaetze) ? s.dropsaetze : [] }))
            : [],
    };
};

export const parseUebungKey = (uiId) => {
    if (typeof uiId !== 'string') return { source: null, uebungId: null };
    const parts = uiId.split('-');
    if (parts.length >= 3) {
        const source = parts[0];
        const uebungId = parseInt(parts[1], 10);
        return { source, uebungId: Number.isNaN(uebungId) ? null : uebungId };
    }
    return { source: parts[0] || null, uebungId: parseInt(parts[parts.length - 1], 10) || null };
};

export const createExerciseItem = (exercise, source = 'standard', index = 0) => {
    const uebungId = exercise.uebung_id || exercise.id || exercise.uebungId;
    const uiId = exercise.uiId || `${source}-${uebungId}-${index}`;
    return { ...exercise, id: exercise.id || uebungId, uebung_id: uebungId, source, uiId, empfohlene_saetze: exercise.empfohlene_saetze || 3 };
};

export const sortByName = (a, b) =>
    (a?.name || '').toString().localeCompare((b?.name || '').toString(), 'de', { sensitivity: 'base' });

export const formatTime = (s) =>
    `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
